import { createRoute,lazyRouteComponent } from '@tanstack/react-router'

import { profileRoute } from '.'

const RedeemBonus = lazyRouteComponent(() => import('../../pages/profile/redeem-bonus'))

export const redeemBonusRoute = createRoute({
  getParentRoute: () => profileRoute,
  path: 'redeem-bonus',
  component: RedeemBonus,
})
